import SectionTitle from "./SectionTitle";
import guideStyles from "../Guide.module.scss";
import styles from "./ListSection.module.scss";

export default function ListSection({
  title,
  icon,
  id,
  items,
  itemType = "object",
  sectionStyle,
  listStyle = "bullet",
  columns = 2,
}) {
  const itemsPerColumn = Math.ceil(items.length / columns);
  const splitColumns = [];

  for (let i = 0; i < columns; i++) {
    const column = items.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn);
    splitColumns.push(column);
  }

  const columnElements = splitColumns.map((column, index) => {
    return (
      <ItemColumn
        column={column}
        key={`column-${index}`}
        listStyle={listStyle}
        itemType={itemType}
      />
    );
  });

  return (
    <section
      className={` 
      ${styles.container}
`}
      id={id ?? ""}
      style={sectionStyle}
    >
      {title && <SectionTitle title={title} icon={icon} />}
      <div className={`${styles.columns} ${styles[`columns-${columns}`]}`}>
        {columnElements}
      </div>
    </section>
  );
}

export function ItemColumn({ column, listStyle, itemType }) {
  let items;

  if (itemType === "object") {
    const parsedColumnItems = column.map((item) => {
      const key = Object.keys(item)[0].replaceAll("_", " ");
      const value = Object.values(item)[0];

      return (
        <li key={`key-fact-${key}`} className={`${styles.item}`}>
          <span className={`${styles.itemTitle}`}>{key}: </span>
          <span>{value}</span>
        </li>
      );
    });

    items = parsedColumnItems;
  } else if (itemType === "component") {
    items = [...column];
  }

  return <ul className={`${styles.column} ${styles[listStyle]}`}>{items}</ul>;
}
